export const getEffectiveObjectId = (wc: {
  objectId?: string | null;
  externalObjectId?: string | null;
}) => wc.objectId ?? wc.externalObjectId ?? '';
